import { render } from "./MesInformations.vue?vue&type=template&id=00728480"
import script from "./MesInformations.vue?vue&type=script&lang=js"
export * from "./MesInformations.vue?vue&type=script&lang=js"

import "./MesInformations.vue?vue&type=style&index=0&id=00728480&lang=css"
script.render = render

export default script